exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading{display:flex;flex-wrap:wrap}.heading>h1{position:relative;margin:0;font-size:32px;line-height:35px}.heading>h1>span{overflow:hidden;display:inline-block}.heading>h1>span>span{display:inline-block;transform:translateY(135%);transition:all .4s}.heading>h1>span.animated>span{transform:translateY(0)}.heading>h1>span.white{color:#fff}.heading>h1>span.green{color:#76b72a}.heading.with-out-animation>h1>span>span{transform:translateY(0)}@media (min-width:576px){.heading h1{font-size:60px;line-height:53px}}@media (min-width:992px){.heading>h1{font-size:117px;line-height:100px}.heading>p{font-size:18px}}", ""]);

// exports
